// extracted by mini-css-extract-plugin
export default {"toggle-switch":"QX_rV4e","toggle-switch__label":"w54P8kd","toggle-switch__switch-wrapper":"nI_kYC1","toggle-switch__switch-visual":"XgrRXmF","toggle-switch__input":"YY2GaV0"};